import {AgmMap, MapsAPILoader} from '@agm/core';
import {Location} from '@angular/common';
import {Component, OnDestroy, OnInit, ViewChild, AfterViewInit, ElementRef, NgZone} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {ActivatedRoute, Router} from '@angular/router';
import {Store, select} from '@ngrx/store';
import {BehaviorSubject, combineLatest, fromEvent, merge, Observable, Subscription} from 'rxjs';
// import {User} from '../../../../../core/auth';
import {TranslateService} from '@ngx-translate/core';
// tslint:disable-next-line: max-line-length
import {
    AcSource, AssetClassMapPageRequested,
    AssetClassResidentialModel, AssetClassResidentialsDataSource,
    AssetClassResidentialsService,
    OneAssetClassResidentialDeleted,
    selectAdminTrashedAssetClassResidentialCount,
    selectAssetClassResidentialsLastQuery,
    selectTrashedAssetClassResidentialCount
} from '../../../../../core/comparable';
import {AppState} from '../../../../../core/reducers';
import {LayoutUtilsService, QueryParamsModel, TypesUtilsService} from '../../../../../core/_base/crud';
import {LayoutConfigService, SubheaderService} from '../../../../../core/_base/layout';
import {debounceTime, distinctUntilChanged, tap, take, map} from 'rxjs/operators';
// import {FilterModel} from '../../_sub/filter-dialog/filter.model';
import {FilterDialogComponent} from '../../_sub/filter-dialog/filter-dialog.component';
import {MarkerInfoDialogComponent} from '../../_sub/map-info-dialog/marker-info-dialog.component';
import {Overlay} from '@angular/cdk/overlay';
import { madCalculator } from 'src/app/core/_base/crud/utils/map-marker.util';
import { MapMarkerInfoWindowComponent, MapMarkerInfoWindowDialogInput } from '../../../shared_components/map-marker-info-window/map-marker-info-window.component';
import { ToMarkerItemConverterService } from '../../../shared_components/map-marker-info-window/to-marker-item-converter-service.service';
import { emptyFilter, FilterChange, FilterModel } from '../../../shared_components/filter-section/filter-section.component';
import { ApartmentTrashFlushed, AssetClassResidentialActionToggleLoading, AssetClassResidentialDeletedFromAdminTrash, AssetClassResidentialDeletedFromTrash, AssetClassResidentialDuplicate, AssetClassResidentialOnServerAdminRestored, AssetClassResidentialOnServerRestored } from 'src/app/core/comparable/_actions/asset-class-residential.actions';
import { FileUploadService } from 'src/app/core/file-upload';
import { User, currentUser, hasPermission } from 'src/app/core/mad-auth/mad-auth.store';
import { environment } from 'src/environments/environment';
import { MapsService } from 'src/app/core/map/maps.service';
import { zoomForViewport } from 'src/app/core/v2/map/viewport-to-zoom';
import { parcelCharacteristicsReducer } from 'src/app/core/linked-tables';


@Component({
    selector: 'kt-apartment-edit',
    templateUrl: './apartment-map.component.html',
    styleUrls: ['./apartment-map.component.scss'],
})
export class ApartmentMapComponent implements OnInit, OnDestroy, AfterViewInit {

    calculator = madCalculator;
    icon = {
        url: './assets/media/icons/my_marker.svg'
    };

    displayedColumns = ['id', 'sub_type', 'building_id', 'size', 'consideration', 'source_date', 'actions'];
    dataSource: AssetClassResidentialsDataSource;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild('sort1', {static: true}) sort: MatSort;
    @ViewChild('fileInput') fileInput;

    @ViewChild('search', {static: false})
    public searchElementRef: ElementRef;
    // @ViewChild('searchLocation', {static: true}) searchElementRef: ElementRef;
    // @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
    assetClassResidentialResult: AssetClassResidentialModel[] = [];

    marker: google.maps.Marker;
    // markerData: { lat: number, lng: number, data: any[] }[] = [];
    markerData = new Map();
    markerData$ = new BehaviorSubject(new Map());
    selectedId: string;
    mapAction = new BehaviorSubject<boolean>(true);
    previous;


    private componentSubscriptions: Subscription;
    subscriptions: Subscription[] = [];
    // currentUser: User;
    saveState: boolean;

    loading$: Observable<boolean>;
    hasFormErrors = false;

    // map
    @ViewChild('AgmMap', {static: true}) agmMap: AgmMap;
    isFirst = true;
    latLngSW: google.maps.LatLng;
    latLngNE: google.maps.LatLng;
    map: any;
    zoom = 15;
    private _centerLat$ = new BehaviorSubject<number>(null)
    centerLatitude$ = combineLatest([
        this._centerLat$.asObservable(),
        this.mapsService.latitude$
    ]).pipe(
        map(([lat, _default]) => {
            if (lat === null) return _default
            return lat
        })
    );
    private _centerLng$ = new BehaviorSubject<number>(null)
    centerLongitude$ = combineLatest([
        this._centerLng$.asObservable(),
        this.mapsService.longitude$
    ]).pipe(
        map(([lat, _default]) => {
            if (lat === null) return _default
            return lat
        })
    );
    currentCenter: { lat: 0, lng: 0 };
    _north = new BehaviorSubject<number>(47.92399006317647);
    _south = new BehaviorSubject<number>(47.9096089375195);
    _east = new BehaviorSubject<number>(106.9476215928344);
    _west = new BehaviorSubject<number>(106.8833344071655);

    filterModel: FilterModel = emptyFilter();
    filterCnt = 0;
    private modal;
    filter$: BehaviorSubject<FilterModel> = new BehaviorSubject(this.filterModel);
    filterObs$ = this.filter$.asObservable();

    // Last Query Params
    lastQueryParams: QueryParamsModel;
    trashCnt = 0;
    adminTrashCnt = 0;
    fileType = 'application/json';
    menuItems = [
        {
            title: 'Import',
            icon: 'flaticon2-add',
            refId: 0,
            disabled: false
        },
        {
            title: 'Download Template',
            icon: 'flaticon2-download',
            refId: 1,
            disabled: false
        },
        {
            title: 'Export',
            icon: 'flaticon2-box-1',
            refId: 2,
            disabled: true
        }
    ];
    menuSubject = new BehaviorSubject<number>(-1);
    canAccessAdminTrash$ = this.store.pipe(select(hasPermission(['admin_trash'])))
    currentUser: User | null;

    private geoCoder = new google.maps.Geocoder();

    /**
     * Component constructor
     *
     * @param assetClassResidentialsService: AssetClassResidentialsService
     * @param activatedRoute: ActivatedRoute
     * @param router: Router
     * @param fb: FormBuilder
     * @param location: Location
     * @param subheaderService: SubheaderService
     * @param typesUtilsService: TypesUtilsService
     * @param layoutUtilsService: LayoutUtilsService
     * @param store: Store
     * @param dialog: Dialog
     * @param overlay: Overlay
     * @param mapsAPILoader: MapsAPILoader
     * @param ngZone: NgZone
     * @param layoutConfigService: LayoutConfigService
     * @param translate: TranslateService
     */
    constructor(public assetClassResidentialsService: AssetClassResidentialsService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private fb: UntypedFormBuilder,
                private location: Location,
                private subheaderService: SubheaderService,
                public typesUtilsService: TypesUtilsService,
                private layoutUtilsService: LayoutUtilsService,
                private store: Store<AppState>,
                public dialog: MatDialog,
                public overlay: Overlay,
                private mapsAPILoader: MapsAPILoader,
                private ngZone: NgZone,
                private layoutConfigService: LayoutConfigService,
                private translate: TranslateService,
                public service: AssetClassResidentialsService,
                private toMarkerItemService: ToMarkerItemConverterService,
                private fileUploadService: FileUploadService,
                private mapsService: MapsService
                ) {
        this.saveState = false;
    }

    ngAfterViewInit(): void {

    }

    ngOnInit() {
        const userSub = this.store.select(currentUser).subscribe(user => this.currentUser = user)
        this.subscriptions.push(userSub);
        // this.filterModel = new FilterModel();
        // this.filterModel.clear();

        this.loading$ = this.mapAction.asObservable();

        this.paginator._intl.itemsPerPageLabel = 'Display';
        // If the user changes the sort order, reset back to the first page.
        const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        this.subscriptions.push(sortSubscription);

        /* Data load will be triggered in two cases:
        - when a pagination event occurs => this.paginator.page
        - when a sort event occurs => this.sort.sortChange
        **/
        const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page).pipe(
            tap(() => this.loadList())
        ).subscribe();
        this.subscriptions.push(paginatorSubscriptions);


        this.dataSource = new AssetClassResidentialsDataSource(this.store);
        const entitiesSubscription = this.dataSource.entitySubject.subscribe(res => {
            this.assetClassResidentialResult = res;
            this.markerData.clear();
            res.forEach(el => {
                const key = el.locationData.latitude + '_' + el.locationData.longitude;
                if (this.markerData.has(key)) {
                    const tmp = this.markerData.get(key);
                    tmp.title = tmp.title + '/' + el.ref_num;
                    tmp.data.push(el);
                    this.markerData.set(key, tmp);
                } else {
                    this.markerData.set(key, {
                        data: [el], 
                        title: '' + el.ref_num, 
                        lat: el.locationData.latitude, 
                        lng: el.locationData.longitude, 
                    });
                }
            });
            this.markerData$.next(this.markerData);
            this.mapAction.next(false);
        });

        this.subscriptions.push(entitiesSubscription);

        // Last Query Params
        this.lastQueryParams = new QueryParamsModel({});
        const lastyQueryParamsSubscriptions = this.store.pipe(
            select(selectAssetClassResidentialsLastQuery),
            take(1)
        ).subscribe(res => {
            if (res.isEmpty()) {
                return;
            }
            this.lastQueryParams = res;
            this.updateFilter(res.filter);
        });
        this.subscriptions.push(lastyQueryParamsSubscriptions);

        const selectTrashedSubscription = this.store.pipe(
            select(selectTrashedAssetClassResidentialCount)
        ).subscribe(res => {
            this.trashCnt = res;
        });
        this.subscriptions.push(selectTrashedSubscription);

        const selectAdminTrashedSubscription = this.store.pipe(
            select(selectAdminTrashedAssetClassResidentialCount)
        ).subscribe(res => {
            this.adminTrashCnt = res;
        });
        this.subscriptions.push(selectAdminTrashedSubscription);

        const menuSubjectSubscribe = this.menuSubject.asObservable().subscribe(refId => {
            switch (refId) {
                case 0:
                    this.addFiles();
                    break;
                case 1:
                    this.downloadJsonTemplate();
                    break;
                case 2:
                    // TODO: export comparables
                    break;
                default:
                    break;
            }
        });
        this.subscriptions.push(menuSubjectSubscribe);
    }

    onFilterChange(event: FilterChange) {
        if (event.page != null) {
            this.paginator.pageIndex = event.page
        }
        this.filterModel = event.filter;
        this.loadList();
    }

    ngOnDestroy(): void {
        if (this.componentSubscriptions) {
            this.componentSubscriptions.unsubscribe();
        }
        this.subscriptions.forEach(_subscription => {
            _subscription.unsubscribe();
        });
    }

    back() {
        this.location.back();
    }

    /**
     * Alert close event
     */
    onAlertClose($event) {
        this.hasFormErrors = false;
    }

    navToList() {
        // this.router.navigate(['../'], {relativeTo: this.activatedRoute});
        const url = `${this.layoutConfigService.getCurrentMainRoute()}/comparable/apartments`;
        this.router.navigate([url], {relativeTo: this.activatedRoute});
    }


    getLabel(title) {
        return {
            color: '#000000',
            fontFamily: '',
            fontSize: '14px',
            fontWeight: 'bold',
            className: 'bg-op',
            text: title,
        };
    }


    /** ACTIONS */
    /**
     * Deleting comparabable residential into trash
     *
     * @param _item: AssetClassResidentialModel
     */
    deleteAssetClassResidential(_item: AssetClassResidentialModel) {
        this.store.dispatch(new OneAssetClassResidentialDeleted({id: _item.id}));
        //
        // const index = this.assetClassResidentialResult.findIndex(e => e.id == _item.id);
        // if (index) {
        //     this.assetClassResidentialResult.slice(index, 1);
        //     // this.dataSource.data = this.assetClassResidentialResult;
        // }
    }

    addResidential() {
        this.editAssetClassResidential(null);
    }

    editAssetClassResidential(assetClassResidentialModel: AssetClassResidentialModel) {
        if (assetClassResidentialModel) {
            this.router.navigate(['../edit', assetClassResidentialModel.id], {relativeTo: this.activatedRoute});
        } else {
            this.router.navigate(['../add'], {relativeTo: this.activatedRoute});
        }
    }

    loadList() {
        let queryParams = null;
        if (this.lastQueryParams.isEmpty()) {
            queryParams = new QueryParamsModel(
                this.filterModel,
                this.sort.direction,
                this.sort.active,
                this.paginator.pageIndex + 1,
                this.paginator.pageSize
            );
        } else {
            queryParams = this.lastQueryParams;
        }
        // Call request from server
        this.lastQueryParams = new QueryParamsModel({});
        this.store.dispatch(new AssetClassMapPageRequested({page: queryParams}));
    }

    // resetFilter(): any {
    //     this.filterCnt = 0;
    //     const _new = new FilterModel();
    //     _new.clear();

    //     _new.max_lng = this.filterModel.max_lng;
    //     _new.min_lat = this.filterModel.min_lat;
    //     _new.max_lat = this.filterModel.max_lat;
    //     _new.min_lng = this.filterModel.min_lng;

    //     _new.sw_lat = this.filterModel.sw_lat;
    //     _new.ne_lat = this.filterModel.ne_lat;
    //     _new.sw_lng = this.filterModel.sw_lng;
    //     _new.ne_lng = this.filterModel.ne_lng;

    //     this.filterModel = _new;

    //     this.searchElementRef.nativeElement.value = '';
    //     this.searchInput.nativeElement.value = '';

    //     this.lastQueryParams = new QueryParamsModel({});
    //     this.loadList();
    // }

    getDate(_source: AcSource): Date {
        const _dateStr = _source.source_type_id == 1 ? _source.transaction_date : _source.information_date;
        return new Date(_dateStr);
    }

    goList() {
        this.router.navigate(['../'], {relativeTo: this.activatedRoute});
    }


    // showFilter() {
    //     const dialogRef = this.dialog.open(FilterDialogComponent, {
    //         data: {
    //             filter: this.filterModel
    //         }
    //     });

    //     dialogRef.afterClosed().subscribe((res) => {
    //         if (!res) {
    //             return;
    //         }

    //         this.filterModel = res.filter as FilterModel;
    //         this.filterCnt = FilterModel.fCount(this.filterModel);
    //         this.loadList();
    //         return;
    //     });
    // }

    updateFilter(filter: FilterModel) {
        // this.searchInput.nativeElement.value = filter.name;
        // this.searchElementRef.nativeElement.value = filter.city_name;
        // this.filterModel = filter;
        // this.filterCnt = FilterModel.fCount(this.filterModel);

        // this._north.next(filter.max_lat);
        // this._south.next(filter.min_lat);

        // this._east.next(filter.max_lng);
        // this._west.next(filter.min_lng);
        this.filter$.next(filter);
    }

    setLocation() {
        this.setCurrentLocation();
    }

    // Get Current Location Coordinates
    private setCurrentLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position.coords.latitude && position.coords.longitude) {
                    this.zoom = 15;
                }
            });
        } else {
            alert('Position not available');
        }
    }


    zoomChanged($event) {
        this.isFirst = true;
    }

    boundsChanged(_latLngBound) {
        if (_latLngBound == null) {
            return;
        }

        this.latLngNE = _latLngBound.getNorthEast();
        this.latLngSW = _latLngBound.getSouthWest();

        const xPadding = (this.latLngNE.lat() - this.latLngSW.lat()) * 0.08;
        this._north.next(this.latLngNE.lat() - xPadding);
        this._south.next(this.latLngSW.lat() + xPadding);

        this._east.next(this.latLngNE.lng() - xPadding);
        this._west.next(this.latLngSW.lng() + xPadding);
        const _new = Object.assign({}, this.filterModel) as FilterModel;
        // _new.max_lat = this._north.value;
        // _new.max_lng = this._east.value;
        // _new.min_lat = this._south.value;
        // _new.min_lng = this._west.value;

        if (_new.bounds == null) {
            _new.bounds = {ne_lat: 0, sw_lat: 0, ne_lng: 0, sw_lng: 0}
        } else {
            _new.bounds = Object.assign({}, _new.bounds);
        }
        _new.bounds.sw_lat = _latLngBound.getSouthWest().lat();
        _new.bounds.ne_lat = _latLngBound.getNorthEast().lat();
        _new.bounds.sw_lng = _latLngBound.getSouthWest().lng();
        _new.bounds.ne_lng = _latLngBound.getNorthEast().lng();

        this.filterModel = _new;

        if (this.isFirst) {
            if (this.modal) {
                this.modal.close();
            }
            this.previous = null;
            this.mapAction.next(true);
            this.isFirst = !this.isFirst;
            this.paginator.pageIndex = 0;
        }
        this.loadList();
    }

    showInfo(mId, infoData) {
        this.selectedId = mId;

        const data = this.toMarkerItemService.convert('comparable', infoData.map(id => ({...id, ac_type: 1})));
        this.dialog.open<MapMarkerInfoWindowComponent, MapMarkerInfoWindowDialogInput>(MapMarkerInfoWindowComponent, {
            data: {
                modal_title: data.modal_title,
                entities: data.entities
            }
        });
    }

    mapReady(event: any) {

        // agmMap
        this.map = event;
        this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(document.getElementById('Profile'));

        this.map.addListener('dragend', () => {

            this.mapAction.next(true);
            this.paginator.pageIndex = 0;
            this.loadList();
        });

        this.mapsAPILoader.load().then(() => {
            this.geoCoder = new google.maps.Geocoder();
            if (this.searchElementRef) {
            const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ['geocode']
            });
            autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                // get the place result
                const place: google.maps.places.PlaceResult = autocomplete.getPlace();
                // verify result
                if (place.geometry === undefined || place.geometry === null) {
                    return;
                }

                // set latitude, longitude and zoom
                this._centerLat$.next(place.geometry.location.lat())
                this._centerLng$.next(place.geometry.location.lng())
                this.zoom = zoomForViewport(place.geometry.viewport);
                });
            });
            }
        });
    }

    centerChange($event: any) {
        if ($event) {
            this.currentCenter = {lat: $event.lat, lng: $event.lng};
        }
    }

    mapClick(event: any) {
        if (this.modal) {
            this.modal.close();
        }

        this.modal = null;
    }

    getItemCssClassByStatus(status: number): string {
        switch (status) {
            case 0:
                return 'warning';
            case 2:
                return 'info';
            default:
                return 'success';
        }
    }
    getItemStatusString(status: number): string {
        switch (status) {
            case 0:
                return 'Draft';
            case 2:
                return 'imported';
            default:
                return 'Validated';
        }
    }

    trash() {
        this.store.dispatch(new AssetClassResidentialActionToggleLoading({isLoading: true}));
        this.service.getTrashed().subscribe(res => {
            this.store.dispatch(new AssetClassResidentialActionToggleLoading({isLoading: false}));
            const items = [];
            res.data.forEach(elem => {
                items.push({
                    text: `#${elem.ref_num} - ${elem.residential_type_name}`,
                    id: elem.id.toString(),
                    date: elem.user_deleted,
                    deletedUser: elem.userDeletedBy,
                    hasPermanentlyDelete: true
                });
            });
            this.show_trash(items);
        });
    }

    // Fetch admin trash data
    adminTrash() {
        this.store.dispatch(new AssetClassResidentialActionToggleLoading({isLoading: true}));
        this.service.getAdminTrashed().subscribe(res => {

            this.store.dispatch(new AssetClassResidentialActionToggleLoading({isLoading: false}));
            const items = [];
            res.data.forEach(elem => {
                items.push({
                    text: `#${elem.ref_num} - ${elem.residential_type_name}`,
                    id: elem.id.toString(),
                    hasPermanentlyDelete: true,
                    date: elem.deleted_at,
                    deletedUser: elem.deletedBy,
                });
            });
            this.show_trash(items, true);
        });
    }

    show_trash(items: any[], isAdmin = false) {
        let _title = this.translate.instant('APARTMENT.LIST.DIALOG.SHOW_TRASH.TITLE');
        if (isAdmin) {
            _title = this.translate.instant('APARTMENT.LIST.DIALOG.SHOW_TRASH.TITLE_ADMIN');
        }

        this.layoutUtilsService.trashedEntities(_title, items, this, isAdmin);
    }

    restore(_id: number, isAdmin = false) {
        if (isAdmin) {
            this.store.dispatch(new AssetClassResidentialOnServerAdminRestored({id: _id}));
        } else {
            this.store.dispatch(new AssetClassResidentialOnServerRestored({id: _id}));
        }

    }

    delete(id: number) {
        this.store.dispatch(new AssetClassResidentialDeletedFromTrash({assetClassResidentialId: id}));
    }

    hardDelete(id: number) {
        this.store.dispatch(new AssetClassResidentialDeletedFromAdminTrash({id}));
    }


    flush() {
        this.store.dispatch(new ApartmentTrashFlushed());
    }

    addFiles() {
        this.fileInput.nativeElement.click();
    }
    
    importComparable(event: any) {
        const file: File = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileUploadService.uploadCompJson(formData).subscribe(
            (res) => {
                if (!res) {
                    return;
                }
                if (res.success) {
                    this.loadList();
                }
            },
            (err) => console
        );
    }
    downloadJsonTemplate() {
        this.fileUploadService.compTemplateDownload(1).subscribe(res => {
                if (res.type == 4) {
                    let blob = new Blob([res.body], { type: 'application/json'});
                    let url = window.URL.createObjectURL(blob);
                    var anchor = document.createElement("a");
                    anchor.download = "interval-comp-apartment-template.json";
                    anchor.href = url;
                    anchor.click();
                }
            },
            err => {
                alert("Problem while downloading the file.");
            }
        );
    }

    duplicate(id: number) {
        this.store.dispatch(new AssetClassResidentialDuplicate({id}));
    }
}
